// extracted by mini-css-extract-plugin
export var avatarContainer = "_42-0";
export var gray = "_42-f";
export var green = "_42-c";
export var icon = "_42-9";
export var image = "_42-1";
export var lg = "_42-6";
export var md = "_42-5";
export var presenceDot = "_42-b";
export var red = "_42-d";
export var sm = "_42-4";
export var status = "_42-a";
export var xl = "_42-7";
export var xs = "_42-3";
export var xxl = "_42-8";
export var xxs = "_42-2";
export var yellow = "_42-e";